import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Components & Assets
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LiveChat from '../components/LiveChat';
import QAChatbot from '../components/QAChatBot';
import BackToTopButton from '../components/BackToTopButton';
import ScrollSocialIcons from '../components/ScrollSocialIcons';
import GetQuoteButton from '../components/GetQuoteButton';

import Punsara from '../assets/ceo.webp';
import Bhashaka from '../assets/CFO.webp';
import Suneth from '../assets/amg.webp';
import Shahzad from '../assets/dms.webp';
import Coo from '../assets/coo1.webp';
import coverImage from '../assets/board_room.webp';
import groupPhoto from '../assets/Directo_board.webp';
import "../App.css";

const pillars = [
  {
    img: Punsara,
    name: "Punsara Aravinda",
    role: "Founder / MD / Marine Consultant",
    experience: `T. A. Punsara Aravinda is the Visionary Founder and Managing Director of CIAP (PVT) LTD, bringing together deep technical expertise, operational leadership, and strategic business acumen to drive sustained growth in the Marine and Engineering Sector.

A highly accomplished Marine Engineer holding a UK Class I (Motor) Certificate of Competency, he possesses extensive handson experience across diverse vessel operations, marine engineering systems, ship building and he carries vision towards developing of blue economy for country and regionally. His seagoing career
(2007–2019) spans progressive leadership roles from 4th Engineer to Chief Engineer, providing comprehensive exposure to both Modern And Conventional Propulsion Systems, High and LowPower Machinery, Complex Shipboard Operations, Port Operations and Ship Building. He further strengthens his professional foundation with an MBA from the University of Wolverhampton, a Diploma in Marine Engineering, and PQHRM certification , reflecting strong capabilities in 
strategic management, operational execution, and human capital leadership. Beyond seagoing operations, he has contributed as an Operations Engineer in power plant operations and as a Visiting Lecturer at several universities, actively mentoring
and developing the next generation of marine professionals. 

Under his Leadership, CIAP (PVT) LTD has grown into a trusted provider of Marine Engineering, Ship Repair, Afloat Repairs, Offshore Support, Automation Solutions AndIndustrial Services, Driven by Technical Excellence, Reliability and a Firm Commitment to 
WorldClass Service Standards.`,
    pillar: "Visionary Leadership"
  },
  {
    img: Bhashaka,
    name: "Bhashaka Gunathilaka",
    role: "Director - Finance & Strategy",
    experience: `Bhashaka Gunathilaka, MBA, ACMA, CGMA, MAAT, is the Director – Finance & Strategy at CIAP PVT LTD, bringing over 20 years of multinational experience across finance, corporate planning and business transformation. Having held senior leadership roles within 
    leading multinational organizations across three countries, he brings a
strong blend of financial intelligence, commercial insight and leadership expertise to the organization.

At CIAP, he leads the company’s Financial Strategy, Capital Structuring, Corporate Governance and Long-Term Business Planning, playing a key role in driving sustainable growth,
operational resilience and business expansion.
Recognized for his forward-thinking leadership and analytical approach, Bhashaka combines financial discipline with commercial vision to strengthen CIAP’s position as a trusted and Future-Ready Marine Engineering and Infrastructure Partner in the Global Market.`,
    pillar: "Financial Integrity"
  },
  {
    img: Coo,
    name: "Rear Admiral (Rtd.) Chandana N. Rathnayake",
    role: "Chief Operating Officer (COO)",
    experience: `Rear Admiral (Rtd.) Chandana N. Rathnayake stands as a driving force behind the Operational Excellence and Strategic Direction of CIAP PVT LTD. Backed by a Distinguished Naval Career, he brings decades of command Experience, Disciplined Leadership and Mission-Critical Decision-Making into the Maritime and Engineering Industry.

As a former Flag Officer, his expertise extends far beyond Conventional Operations. Combining Battlefield-Level precision with Corporate Strategy, he has become the architect of CIAP’s Operational Framework — leading with Vision, Resilience, and
Uncompromising Standards. Strengthened by a PhD in Logistics, 
Rear Admiral Rathnayake uniquely integrates military discipline with advanced logistics and Operational Theory. This rare combination
empowers CIAP to streamline Maritime Operations, Eliminate Inefficiencies and Deliver Superior Technical Seaworthiness with Unmatched Precision and Reliability. His Leadership continues to elevate CIAP as a trusted force in Marine Engineering,Ship Repair, 
Offshore Support and Operational Innovation Across the Industry.`,
    pillar: "Operational Excellence"
  },
  {
    img: Shahzad,
    name: "M. Shahzad Ghany",
    role: "Head of Strategic Markets",
    experience: `M. Shahzad Ghany brings Decades of Industry Expertise, Global market knowledge and Strategic Business Vision to “CIAP”. With an outstanding Professional Journey spanning over Four Decades since 1980, he has played a pivotal role in building International Partnerships, Strengthening Global Networks and Driving Strategic Market Expansion.

As Head of Strategic Markets, he leads “Team CIAP’s” efforts in identifying new business opportunities, fostering long-term International Collaborations and Expanding the Company’s presence across Regional and Global Maritime and Engineering Sectors. His deep understanding of International Trade Dynamics, Market Development and Business Relationships has Positioned “CIAP” as a Growing Force in the Global Industry Landscape.

Known for his Strong Commercial Insight and Relationship-Driven Leadership, he continues to open new pathways for Growth, Innovation and International Recognition — Reinforcing “CIAP’s” vision of becoming a Globally Trusted Name in Marine Engineering, Offshore Support and Industrial Solutions – The Architect of “ Total Marine & Engineering Solutions” – based in Sri Lanka & Serving Globally.`,
    pillar: "Strategic Growth"
  },
  {
    img: Suneth,
    name: "Suneth Karunathilakarathne",
    role: "Assistant General Manager - Technical | Operation | Sourcing",
    experience: `Eng. Suneth Karunathilakarathne is a dynamic Marine Engineering Professional whose Technical Expertise and Operational Leadership continue to strengthen the foundation of CIAP PVT LTD. Holding a Certificate of Competency Class II (Motor), he brings a wealth of practical knowledge and engineering excellence gained through years 
    of experience in Marine Machinery Operations, Technical Management and Vessel Engineering Systems.

As Assistant General Manager, he plays a vital role in driving Operational Performance, Overseeing Technical Execution, and ensuring the seamless delivery of High-Quality Engineering Solutions across Marine and Industrial Projects. His ability to combine
hands-on Engineering Capability with Strategic Operational Coordination makes him a key force behind CIAP’s efficiency, reliability and service excellence. Recognized for his Problem-Solving Mindset, Disciplined Leadership and Commitment to Technical Precision, Eng. Suneth continues to contribute toward CIAP’s reputation as a Trusted Leader in Marine Engineering, Ship Repair, Offshore Support and Industrial Innovation.`,
    pillar: "Industrial Reliability"
  }
];

const Leadership = () => {
  const [selectedLeader, setSelectedLeader] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setSelectedLeader(null);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (selectedLeader) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [selectedLeader]);

  return (
    <div className="leadership-page">
      <Navbar />

      <div className="jat-leadership-cover-container">
        <div className="jat-leadership-cover-overlay"></div>
        <img src={coverImage} alt="Leadership Cover" className="jat-leadership-cover" />
        <h3 className="jat-leadership-cover-title">Leadership</h3>
        <div className="leadershipMainBanner__right">
          <div className="leadershipMainBanner__card">
            <p className="leadershipMainBanner__cardText">We build your future with excellence that lasts a lifetime.</p>
            <Link to="/contact" className="leadershipMainBanner__cta">
              <span className="leadershipMainBanner__ctaIcon arrowBox">
                <span className="arrow">→</span>
              </span>
              <span className="leadershipMainBanner__ctaText">Contact Us</span>
            </Link>
          </div>
        </div>
      </div>

      <section className="jat-hero-text-section">
        <div className="jat-hero-content">
          <h1>The Five Pillars of Leadership</h1>
          <div className="jat-hero-text">
            <p>
              Since our inception, CIAP has grown in scale, strength, and reputation under disciplined and forward-thinking leadership.
              Our leadership team combines maritime expertise with strong governance to drive strategic expansion, operational excellence,
              and sustainable growth across regional and international markets.
            </p>
            <p>
              The vision, leadership, and integrity of our team guide CIAP toward global standards of engineering excellence.
            </p>
          </div>
        </div>
      </section>

      <section className="jat-leaders-section">
        <div className="jat-leaders-container">
          <h2 className="jat-section-title">Board of Directors & Management</h2>
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            autoHeight={false} // Crucial for equal height
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1300: { slidesPerView: 5 },
            }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            navigation={true}
            className="jat-leaders-swiper"
          >
            {pillars.map((leader, index) => (
              <SwiperSlide key={index} style={{ height: 'auto' }}>
                <div
                  className="jat-leader-card"
                  onClick={() => setSelectedLeader(leader)}
                >
                  <div className="jat-leader-img-wrapper">
                    <img src={leader.img} alt={leader.name} loading="lazy" />
                    <div className="jat-leader-hover-overlay">
                      <span className="jat-read-more">+ Read More</span>
                    </div>
                  </div>
                  <div className="jat-leader-info">
                    <h3>{leader.name}</h3>
                    <p>{leader.role}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* Modal Overlay */}
      {selectedLeader && (
        <div className="jat-modal-overlay" onClick={() => setSelectedLeader(null)}>
          <div className="jat-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="jat-modal-close" onClick={() => setSelectedLeader(null)}>&times;</button>
            <div className="jat-modal-body">
              <div className="jat-modal-img">
                <img src={selectedLeader.img} alt={selectedLeader.name} />
              </div>
              <div className="jat-modal-text">
                <h2>{selectedLeader.name}</h2>
                <h4 className="jat-modal-role">{selectedLeader.role}</h4>
                <div className="jat-modal-divider"></div>
                {/* Wrapped in a scrollable container */}
                <div className="jat-experience-scroll">
                  <p className="jat-modal-experience">{selectedLeader.experience}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <section className="jat-who-we-are-section">
        <div className="jat-who-we-are-container">
          <div className="jat-who-content-wrapper">
            <div className="jat-who-header">
              <span className="jat-who-subtitle">About Our Team</span>
              <h2>Who We Are</h2>
              <div className="jat-who-divider"></div>
            </div>
            <div className="jat-who-text">
              <p>Team CIAP is a leading provider of integrated <b>Total Marine and Engineering</b>
                Solutions, delivering specialized services to the Maritime, Offshore and Industrial
                Sectors. With a strong presence in Sri Lanka and a Growing Regional Footprint, we are
                committed to supporting vessel owners, operators and businesses with reliable, efficient
                and technically advanced solutions.</p>
              <p>Our core expertise spans mechanical servicing, ship maintenance, marine refrigeration
                systems and offshore equipment support. In addition, CIAP is highly experienced in
                diagnosing and resolving issues within automated marine systems, including PLCs,
                DCS, SCADA, sensors, actuators and communication networks. We focus on rapid
                response and precision-driven execution to minimize operational downtime and ensure
                optimal system performance.</p>
              <p>At CIAP, we combine technical excellence with a customer-centric approach. Our team
                of Skilled Engineers and Technicians works closely with clients to understand their
                operational needs and deliver tailored solutions that meet International Standards of
                Quality and Safety.</p>
              <p>Driven by innovation and continuous improvement, we strive to enhance efficiency,
                reliability, and sustainability across every project we undertake. Whether supporting
                routine maintenance or complex engineering challenges, CIAP stands as a trusted
                partner in keeping operations running smoothly—at sea and onshore.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="jat-group-photo-section">
        <div className="jat-group-photo-container">
          <img src={groupPhoto} alt="Directors Group" className="jat-group-photo" />
        </div>
      </section>

      <LiveChat />
      <QAChatbot />
      <GetQuoteButton />
      <ScrollSocialIcons />
      <BackToTopButton />
      <Footer />
    </div>
  );
};

export default Leadership;